import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useContext, useState } from 'react';
import { GroupLayer, MapContext } from '@/context/MapContext/MapProvider';

export default function CoverageAccordion({
  expanded,
  handleChange,
  groupLayer,
  checked,
  setChecked,
}: {
  expanded: string | false;
  handleChange: any;
  groupLayer: GroupLayer;
  checked: {
    [key: string]: boolean;
  };
  setChecked: React.Dispatch<
    React.SetStateAction<{
      [key: string]: boolean;
    }>
  >;
}) {
  const { displayGraphicsLayer } = useContext(MapContext);

  //Accordion states
  const [subExpanded, setSubExpanded] = useState<string | false>(false);

  const handleChangeSubExpanded =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      event.stopPropagation();
      event.preventDefault();
      setSubExpanded(isExpanded ? panel : false);
    };

  //list handler
  const handleToggle = (value: string) => () => {
    const geojsonLayer = groupLayer.findLayerById(value);

    geojsonLayer.visible = !checked[value as keyof typeof checked];
    // geojsonLayer.opacity = Number(!checked[value as keyof typeof checked]);

    setChecked({ ...checked, [value]: !checked[value as keyof typeof checked] });
  };

  return (
    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle2">Coverage</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '0px !important' }}>
        {/* Sub list items */}
        <List sx={{ padding: '0 0 0 16px !important' }}>
          <ListItem disablePadding>
            <Accordion
              expanded={subExpanded === 'panel1'}
              onChange={handleChangeSubExpanded('panel1')}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ '&.MuiAccordionSummary-root': { backgroundColor: 'unset !important' } }}
              >
                <Typography>Eagleview</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: '0px !important' }}>
                <FormGroup
                  sx={{
                    paddingLeft: '1rem',
                    '.MuiCheckbox-root': { padding: '0 9px !important', color: 'white' },
                  }}
                >
                  {Object.keys(checked)
                    .reverse()
                    .map(value => {
                      return (
                        <FormControlLabel
                          key={value}
                          control={
                            <Checkbox
                              size="small"
                              checked={checked[value] || false}
                              onChange={handleToggle(value)}
                            />
                          }
                          label={value}
                        />
                      );
                    })}
                </FormGroup>
              </AccordionDetails>
            </Accordion>
          </ListItem>
        </List>
      </AccordionDetails>
    </Accordion>
  );
}
